import type { ApiErrorBody } from '../domain/models';

export const API_URL = (import.meta.env.VITE_API_URL || 'https://cloud-storage-api.yoelfernandez.workers.dev').replace(/\/$/, '');

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

let unauthorizedHandler: (() => void) | null = null;
export function onUnauthorized(handler: () => void): () => void {
  unauthorizedHandler = handler;
  return () => { if (unauthorizedHandler === handler) unauthorizedHandler = null; };
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('cloud_token');
  const headers = new Headers(init.headers);
  if (token) headers.set('authorization', `Bearer ${token}`);
  if (init.body && !(init.body instanceof FormData)) headers.set('content-type', 'application/json');
  let response: Response;
  try {
    response = await fetch(`${API_URL}${path}`, { ...init, headers });
  } catch {
    throw new ApiError(0, 'network_error', 'No pudimos conectar con el servidor.');
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => ({})) as ApiErrorBody;
    if (response.status === 401 && token) unauthorizedHandler?.();
    throw new ApiError(response.status, payload.error?.code ?? 'request_error', payload.error?.message ?? 'Ocurrió un error inesperado.');
  }
  return response.json() as Promise<T>;
}

export const jsonBody = (value: unknown): string => JSON.stringify(value);
